/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* exported RBreadcrumbs */
	
	/**
	 * This file contains React component for Breadcrumbs.
	 *
	 * @author Jordan Stirling
	 * @author Alex Ilea
	 * @author Jake Penny
	 * @version 2.0.0
	 *
	 */
	
	/**
	 * Breadcrumbs Component.
	 * Used for navigation on all Loris pages.
	 */
	var Breadcrumbs = function (_React$Component) {
	  _inherits(Breadcrumbs, _React$Component);
	
	  function Breadcrumbs(props) {
	    _classCallCheck(this, Breadcrumbs);
	
	    var _this = _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, props));
	
	    _this.state = {
	      displayCount: 0
	    };
	
	    _this.checkScreenSize = _this.checkScreenSize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Breadcrumbs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.checkScreenSize();
	      if (typeof window !== 'undefined') window.addEventListener('resize', this.checkScreenSize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (typeof window !== 'undefined') window.removeEventListener('resize', this.checkScreenSize);
	    }
	  }, {
	    key: 'checkScreenSize',
	    value: function checkScreenSize() {
	      // Used to check to current window size and
	      // sets the number of breadcrumbs to show
	      var windowWidth = window.innerWidth;
	      var displayCount = 4;
	
	      if (windowWidth <= 425) {
	        displayCount = 1;
	      } else if (windowWidth <= 500) {
	        displayCount = 2;
	      } else if (windowWidth <= 767) {
	        displayCount = 3;
	      } else if (windowWidth > 885 && windowWidth <= 1350) {
	        displayCount = 3;
	      } else if (windowWidth > 1500) {
	        displayCount = 5;
	      }
	
	      this.setState({
	        displayCount: displayCount
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var baseURL = this.props.baseURL;
	      var breadcrumbs = [];
	      var dropdown = [];
	      var breadcrumbDropdown = void 0;
	
	      // Loop through breadcrumbs either adding them to drop down
	      // or displaying them
	      for (var i = 0; i < this.props.breadcrumbs.length; i++) {
	        var element = this.props.breadcrumbs[i];
	        var url = baseURL + element.query;
	        if (i < this.props.breadcrumbs.length - this.state.displayCount) {
	          dropdown.push(React.createElement(
	            'li',
	            null,
	            React.createElement(
	              'a',
	              { href: url },
	              element.text
	            )
	          ));
	        } else {
	          breadcrumbs.push(React.createElement(
	            'a',
	            { key: 'crumb_' + i, href: url, className: 'btn btn-primary' },
	            React.createElement(
	              'div',
	              null,
	              element.text
	            )
	          ));
	        }
	      }
	
	      if (dropdown.length !== 0) {
	        breadcrumbDropdown = React.createElement(
	          'div',
	          { className: 'btn-group ellipsis btn btn-primary' },
	          React.createElement(
	            'button',
	            { type: 'button',
	              className: 'dropdown-toggle',
	              'data-toggle': 'dropdown',
	              'aria-haspopup': 'true',
	              'aria-expanded': 'false'
	            },
	            '...'
	          ),
	          React.createElement(
	            'ul',
	            { className: 'dropdown-menu' },
	            dropdown
	          )
	        );
	      }
	
	      return React.createElement(
	        'div',
	        { id: 'bc2', className: 'btn-group btn-breadcrumb' },
	        React.createElement(
	          'a',
	          { href: baseURL, className: 'btn btn-primary' },
	          React.createElement('span', { className: 'glyphicon glyphicon-home', 'aria-hidden': 'true' })
	        ),
	        breadcrumbDropdown,
	        breadcrumbs
	      );
	    }
	  }]);
	
	  return Breadcrumbs;
	}(React.Component);
	
	var RBreadcrumbs = React.createFactory(Breadcrumbs);
	
	window.Breadcrumbs = Breadcrumbs;
	window.RBreadcrumbs = RBreadcrumbs;
	
	exports.default = Breadcrumbs;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// htdocs/js/components/Breadcrumbs.js